import { timestampDate } from '@bufbuild/protobuf/wkt';
import { Alert, Box, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { useRequiredSystem } from '~/shared/hooks/system-hooks';
import { useRequiredSimulation } from '~/shared/hooks/useSimulation';
import { createSystemSimulationsRoute } from '~/shared/models/create-routes';

export function SimulationInfoBar() {
  const system = useRequiredSystem();
  const { t } = useTranslation();
  const simulation = useRequiredSimulation();

  return (
    <Box sx={{ display: 'flex', gap: 1, flexDirection: 'column' }}>
      <Alert
        icon="💻"
        severity="error"
        action={
          <Button
            variant="text"
            component={Link}
            to={createSystemSimulationsRoute(system.id)}
            size="small"
            sx={{ ml: 1 }}
          >
            {t('simulations.alert.exit')}
          </Button>
        }
      >
        <Typography>{t('simulations.alert.info')}</Typography>
        <Typography>
          {t('simulations.alert.info2', {
            title: simulation.title,
            timeFrom: timestampDate(simulation.timeFrom).toLocaleDateString(),
            timeTo: timestampDate(simulation.timeTo).toLocaleDateString(),
          })}
        </Typography>
      </Alert>

      {simulation.topologyOutdated && (
        <Alert
          icon="⚠️"
          severity="warning"
          sx={{
            mb: {
              xs: 0,
              sm: -3,
            },
          }}
        >
          <Typography>{t('simulations.topologyOutdated')}</Typography>
        </Alert>
      )}
    </Box>
  );
}
